
// 页数选项
export const pageOptions = [
    { value: '5-10', label: '5-10页' },
    { value: '10-15', label: '10-15页' },
    { value: '15-20', label: '15-20页' },
    { value: '20-25', label: '20-25页' },
    { value: '25-30', label: '25-30页' },
    { value: '30-35', label: '30-35页' },
    { value: '35-40', label: '35-40页' },
    { value: '40-45', label: '40-45页' },
    { value: '20页以内', label: '智能页数' },
  ]
  
  // 文本量选项
  export const textOpts = [
    { value: '详细', label: '详细' },
    { value: '中等', label: '中等' },
    { value: '简洁', label: '简洁' },
  ]
  
  // 受众选项
  export const audiencesOpts = [
    { value: '大众', label: '大众' },
    { value: '医生护士', label: '医生护士' },
    { value: '投资者', label: '投资者' },
    { value: '商业', label: '商业' },
    { value: '学生', label: '学生' },
    { value: '教师', label: '教师' },
    { value: '老板', label: '老板' },
    { value: '面试官', label: '面试官' },
    { value: '员工', label: '员工' },
    { value: '同事同行', label: '同事同行' },
    { value: '在线访客', label: '在线访客' },
    { value: '组员', label: '组员' },
  ]
  
  // 场景选项
  export const sceneOpts = [
    { value: '通用', label: '通用' },
    { value: '项目提案', label: '项目提案' },
    { value: '公众演讲', label: '公众演讲' },
    { value: '工作汇报', label: '工作汇报' },
    { value: '教学课件', label: '教学课件' },
    { value: '作业展示', label: '作业展示' },
    { value: '产品推广', label: '产品推广' },
    { value: '市场宣传', label: '市场宣传' },
    { value: '论文答辩', label: '论文答辩' },
    { value: '学术研究', label: '学术研究' },
    { value: '总结计划', label: '总结计划' },
    { value: '商业洽谈', label: '商业洽谈' },
  ]